import { toChartNumber } from '@/lib/chartUtils';
import { cn } from '@/lib/utils';

/** CSS column chart — no Recharts (avoids DecimalError on empty/zero domains). */
export default function MonthlyCompanyChart({ rows, className }) {
  if (!rows?.length) {
    return (
      <p className={cn('flex h-full items-center justify-center text-xs text-muted-foreground', className)}>
        No monthly data yet
      </p>
    );
  }

  const max = Math.max(...rows.map((r) => toChartNumber(r.count)), 1);

  return (
    <div className={cn('flex h-full gap-1.5 px-1', className)}>
      {rows.map((row) => {
        const count = toChartNumber(row.count);
        const heightPct = Math.max((count / max) * 100, count > 0 ? 6 : 0);
        return (
          <div key={row.month} className="flex min-w-0 flex-1 flex-col items-center">
            <span className="mb-1 font-mono text-[10px] tabular-nums text-foreground/65">{count}</span>
            <div className="flex w-full max-w-[2.75rem] flex-1 items-end justify-center">
              <div
                className="w-full rounded-t-md bg-primary transition-[height] duration-500 ease-out"
                style={{ height: `${heightPct}%`, minHeight: count > 0 ? 4 : 0 }}
                title={`${row.month}: ${count} companies`}
                role="img"
                aria-label={`${row.month}: ${count} companies`}
              />
            </div>
            <span
              className="mt-1.5 max-w-full truncate text-center text-[10px] text-foreground/60"
              title={row.month}
            >
              {row.month}
            </span>
          </div>
        );
      })}
    </div>
  );
}
